import { createSelector } from 'reselect';
import { RootState } from '../model/state';
import MessageState from 'model/state/MessageState';
import { MessageType } from 'model';

/**
 * Direct selector to the state
 */
const selectMessage = () => (state: RootState) => state.message;

/**
 * Other specific selectors
 */
const selectHasErrorMessage = () => createSelector(
  selectMessage(),
  (message: MessageState) => !!(message.type === MessageType.ERROR && message.message)
);

const selectHasSuccessMessage = () => createSelector(
  selectMessage(),
  (message: MessageState) => !!(message.type === MessageType.SUCCESS && message.message)
);

export default selectMessage;
export {
  selectHasErrorMessage,
  selectHasSuccessMessage,
}
